import MenuRenderView from '@dynameat/MenuRenderView';

export const menuPreviewRoutes = [
  {
    path: '/render/:menuGuid/:zoneGuid/:serviceGuid/:year/:month/:day',
    component: MenuRenderView,
    meta: { requiresAuth: true },
    name: 'menu-render-view'
  },
];
